export default __webpack_public_path__ + "static/media/pocket-office.88cd633f.svg";